import React, { useEffect, useState } from "react";

import QuestionBoxInScore from "../QuestionBoxInScore.js/QuestionBoxInScore";
import BetterAnswerModal from "../BetterAnswerModal/BetterAnswerModal";
import { message, Pagination } from "antd";
import ManualResponse from "../../common/AddManualResponses";

const QuestionsAndAnswers = ({
  open,
  fromRating,
  setOpen,
  dataObjects,
  Id,
  IdName,
  dataId,
  rerender,
  setRerender,
  questionId,
  setQuestionId,
}) => {
  const question = "";
  const [questionsToBeShown, setQuestionsToBeShown] = useState([]);
  const [secondInput, setSecondInput] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    setQuestionsToBeShown(dataObjects);
  }, [dataObjects]);

  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 10;

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  const paginatedData = Array.isArray(questionsToBeShown)
    ? questionsToBeShown.slice(
        (pageNumber - 1) * pageSize,
        pageNumber * pageSize
      )
    : [];

  const goToPage = (e, page) => {
    setPageNumber(page - 1);
    console.log(page);
  };

  const getResults = async (question) => {
    return fetch(
      `${process.env.REACT_APP_API_ROOT}/api/bot/getchats/?BotId=${Id}&Question=${question}`,
      { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
    ).then((data) => data.json());
  };

  const getQAs = async (question) => {
    if (IdName == "DataId") {
      return fetch(
        `${process.env.REACT_APP_API_ROOT}/api/data/searchQAs/?DataId=${Id}&Question=${question}`,
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      ).then((data) => data.json());
    } else {
      return fetch(
        `${process.env.REACT_APP_API_ROOT}/api/data/searchQAs/?SourceId=${Id}&Question=${question}`,
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      ).then((data) => data.json());
    }
  };

  const handleClick = () => {
    setIsOpen(true);
    const secondInput = paginatedData[0]?.Question ? "Answer" : "Context";
    setSecondInput(secondInput);
  };
  const handleAddManually = async (e) => {
    e.preventDefault();
    const form = e.target;
    const question = form.question?.value;
    const answer = form.answer?.value;
  
    const body = question
      ? { SourceId: Id, DataId : dataId, Question: question, Answer: answer }
      : { SourceId: Id, DataId : dataId, Context: answer };
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_ROOT}/api/data/addQAmanually/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(body),
      });
  
      const result = await response.json();
  
      if (response.ok) {
        message.success("Manual content has been added!");
        setRerender(!rerender)
        setIsOpen(false)
      } else {
        message.error(result?.detail || "Failed to add content.");
      }
    } catch {
      message.error("An error occurred while submitting the data.");
    }
  };
  

  const searchQuestions = async (e) => {
    var question = document.getElementById("search").value;
    var currentScreen = window.location.href.split("/")[4];
    setSearchQuery(question);
    if (currentScreen == "QuestionsAndAnswers") {
      getQAs(question).then((result) => {
        console.log(result);
        if (typeof result.message == "string") {
          setQuestionsToBeShown([]);
        } else {
          setQuestionsToBeShown(result.message);
        }
      });
    } else {
      getResults(question).then((result) => {
        console.log(result);
        setQuestionsToBeShown(result.message);
      });
    }
  };
  return (
    <div>
      <div>
        <div className="bg-white px-4 py-4 h-full w-full">
          {!fromRating && (
            <div className="flex justify-between items-center mt-5">
              <p className="text-black text-opacity-25">
                {paginatedData[0]?.Question &&
                  "Here is the list of  question in file."}
              </p>
              <button className="primary px-3 py-2" onClick={handleClick}>
                {paginatedData[0]?.Question
                  ? "Add More Question"
                  : "Add Context Manually"}
              </button>
            </div>
          )}
          {paginatedData.map((dataObject) => (
            <div className="mt-6" key={dataObject?.Id || dataObject?.ChatId}>
              <QuestionBoxInScore
                index={dataObject?.Id || dataObject?.ChatId}
                open={open}
                ChatId={dataObject?.ChatId}
                botId={dataObject?.BotId}
                setOpen={setOpen}
                question={dataObject?.Question || dataObject?.Context}
                context={dataObject?.Context}
                AddBetterAnswer={dataObject?.AddBetterAnswer}
                answer={dataObject?.Answer}
                rank={dataObject?.Rating}
                setQuestionId={setQuestionId}
                rerender={rerender}
                setRerender={setRerender}
              />
            </div>
          ))}
        </div>
      </div>
      {Array.isArray(questionsToBeShown) &&
        questionsToBeShown.length > pageSize && (
          <div className="flex justify-center mt-8">
            <Pagination
              current={pageNumber}
              pageSize={pageSize}
              total={questionsToBeShown.length}
              onChange={handlePageChange}
              showSizeChanger={false}
            />
          </div>
        )}

      <ManualResponse
        isOpen={isOpen}
        Second={secondInput}
        onClose={() => setIsOpen(false)}
        text={"Add Content Manually here"}
        handleSubmit={handleAddManually}
        buttonTextOne={"Add Manually"}
      />
    </div>
  );
};

export default QuestionsAndAnswers;
